const commonBondViewTemplate = `
<div class="col-sm-9 col-md-9 col-lg-12 account-detail-main-content-wrapper inner-container with-shadow with-padding">
    
     <div class="page-title">
        <span class="site-logo-wrapper" ng-if="translations.defaultCommonBondFlag">
            <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" class="dnp-modal-logo" alt="site logo">
        </span>
        <span ng-class="translations.defaultCommonBondFlag ? 'dnp-modal-title' : 'dnp-modal-custom-title'">{{'accountList.commonBond.empowerStudentDebt' | translate}}</span>
    </div>
 
    <div>
        <p class="dnp-paragraph">{{'accountList.commonBond.empowerStudentDebtDetails' | translate}} </p>
        <p>{{'accountList.commonBond.continueLink' | translate}} </p>
        <p>{{'accountList.commonBond.personalDataDisclaimer' | translate}} <a target="_blank" ng-if="translations.defaultCommonBondFlag" ng-href="{{translations.empowerPolicyLink}}">{{'accountList.commonBond.empowerPolicy' | translate}}</a><span ng-if="translations.defaultCommonBondFlag"> {{'accountList.commonBond.and' | translate}}</span> <a target='_blank' ng-href="{{translations.commonBondPolicyLink}}">{{'accountList.commonBond.commonBondPolicy' | translate}}</a> {{'accountList.commonBond.continueAcknowledge' | translate}} <a ng-href="{{translations.empowerCommonbondTermsPDF}}" target='_blank'>{{'accountList.commonBond.empowerCommonbondTerms' | translate}}</a> {{'accountList.commonBond.empowerThirdPartyBene' | translate}}</p>        
        <p>{{'accountList.commonBond.empowerStudentDebtDisclaimer' | translate}}</p>
        <p>{{'accountList.commonBond.clickContinue' | translate}}</p>
    </div>

    <div class="row">
        <hr>
        <button type="button" class="btn btn-link pull-left ng-binding" data-dismiss="modal" ng-click="dismiss()">{{'accountList.commonBond.cancel' | translate}}</button>
        <button class="btn btn-primary pull-right" ng-click="continueClick()">{{'accountList.commonBond.continue' | translate}}</button>
        <form class="hide" id="SAMLFORM{{uniqueId}}" method="post" target="_blank"></form>
    </div>
<div>
`;
export default commonBondViewTemplate;
